import React, { useState } from "react";
import { observer } from "mobx-react";

import { Button, Card, Paper } from "../../../../common/components/libs";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import styled from "styled-components";
import { Coupon, CouponData, CouponType } from "../../../../services/coupons/models";
import { convertDate } from "../../../../common/libs";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import { CouponsFormType } from "../../store/forms";
import {Trans, useTranslation} from "react-i18next";
import { useStores } from "../../../../hooks";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
`;

interface CouponsListProps {
    coupons: Coupon[];
    delete: (id: number) => void;
    edit: (data: CouponData, couponId: number) => void;
    showForm: (type: CouponsFormType, coupon: Coupon) => void;
}

const CouponsList = (props: CouponsListProps) => {
    const { coupons } = props;
    const { couponsStore, constantsStore } = useStores();
    const [deleteCouponConfirmationDialog, setDeleteCouponConfirmationDialog] = useState(false);
    const [selected, setSelected] = useState<Coupon>();

    const openDeleteConfirmationDialog = (coupon: Coupon) => {
        setDeleteCouponConfirmationDialog(true);
        setSelected(coupon)
    }

    const closeDialog = () => {
        setDeleteCouponConfirmationDialog(false);
    }



    const {i18n, t} = useTranslation(["general", "coupons"]);
    const { generalStore } = useStores();
    const locale = generalStore.locale.id
    return (
        <Card mb={3}>
            <Paper>
                <TableWrapper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        width: 20
                                    }}
                                >
                                     {t("coupons:coupon")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 20
                                    }}
                                >
                                    {t("coupons:discount")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 20
                                    }}
                                >
                                    {t("coupons:numberOfUses")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 50
                                    }}
                                >
                                    {t("coupons:validity")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 50
                                    }}
                                >
                                    {t("general:actions")}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {coupons.map((coupon) => {
                                let amount = '';
                                if (coupon.data.type === CouponType.percentage) {
                                    amount = `${coupon.data.discountPercent} %`
                                } else if (coupon.data.type === CouponType.fixedAmount) {
                                    const formatter = constantsStore.getCurrencyFormatter(coupon.data.discountAmount.currencyId);
                                    amount = `${formatter.toShowFormatted(coupon.data.discountAmount.amount)}`
                                }
                                return (
                                    <TableRow key={coupon.id}>
                                        <TableCell scope="row" style={{
                                            width: 20
                                        }}>
                                            {coupon.data.code}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 20
                                        }}>
                                            {coupon.data.type === CouponType.percentage ? coupon.data.discountPercent + "%" : coupon.data.discountAmount.amount + generalStore.currency.currencyShortName[locale]}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 20
                                        }}>
                                            {coupon.data.totalUsagesLimit}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 50
                                        }}>
                                            {convertDate(coupon.data.startDate)} – {convertDate(coupon.data.endDate)}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton aria-label="delete"
                                                        onClick={() => props.showForm(CouponsFormType.createCoupon, coupon)}>
                                                <EditIcon/>
                                            </IconButton>
                                            <IconButton aria-label="delete"
                                                        onClick={() => openDeleteConfirmationDialog(coupon)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            }
                        </TableBody>
                    </Table>
                </TableWrapper>
            </Paper>
            <Dialog
                open={deleteCouponConfirmationDialog}
                onClose={closeDialog}
            >
                <DialogTitle >
                    {t("coupons:deleteCoupon")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        <Trans i18nKey="coupons:afterDeletingCoupon" values={{code: selected?.data.code}}/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>{t("general:cancel")}</Button>
                    <Button onClick={() => {
                        props.delete(selected?.id);
                        closeDialog()
                    }} autoFocus variant={'contained'} color={'primary'}>
                        {t("general:delete")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};

export default observer(CouponsList);
